<script setup lang="ts">
import { PillProps } from "./Pill.props"
import { iconsSrcMap } from "./Pill.iconMapping"

defineProps<PillProps>()
</script>

<template>
  <div
    class="
      badge-pill
      inline-flex
      items-center
      gap-1
      rounded-full
      border border-black-10
      bg-white
      px-2
      py-[6px]
    "
  >
    <UtilsIcon v-bind="iconsSrcMap[iconType]" class="h-6 w-6" />
    <span class="mouse-bold md:beaver-bold">
      {{ $t(`badge.${iconType}`) }}
    </span>
  </div>
</template>
